import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormGroupDirective } from '@angular/forms';
import { AppMainComponent } from '../../../../../app.main.component';
import { Status } from '../../../models/status';
import { AddressTypeService } from './address-type-modal.service';
import { ConfirmationService, LazyLoadEvent, MenuItem, MessageService } from 'primeng/api';
import { AppMainService } from 'src/app/app-main.service';
import { TypeGroupIds } from '../../../constants/category-groupid.constants';

@Component({
    selector: 'app-lion-address-type-modal',
    templateUrl: './address-type-modal.html',
    styleUrls: ['./address-type-modal.scss'],
    providers: [ConfirmationService]
})
export class LionAddressTypeModalComponent implements OnChanges, OnInit {

    accountAddressTypes = [];
    contactListAttn = [];
    selectedAddressType = null;
    displayAddAddrType:boolean = false;
    showPlaceElm: boolean = false;
    tempAddrType = {
        "id": 0,
        "createdSource": this.app.user.userIP,
        "updatedSource": null,
        "createdBy": this.app.user.userId,
        "updatedBy": null,
        "createdDate": new Date(),
        "updatedDate": null,
        "name": "",
        "parentTypeId": 0,
        "description": null,
        "groupId": TypeGroupIds.AddressTypeCoreAPI,// as discussed with ankush it will be 11
        "organizationId": this.app.user.organizationId,
        "colorCodeId": 0,
        "statusId": Status.Active
    }

    constructor(
        public app: AppMainComponent,
        private addressTypeService: AddressTypeService,
        public confirmationService: ConfirmationService,
        private messageService: MessageService,
        public appMainService: AppMainService,


    ){}



    @Input() display:boolean;
    @Input() addressTypeList = [];


    @Output() onCancel = new EventEmitter();
    @Output() onSave = new EventEmitter();
    @ViewChild('addAdddressTypeFrm') addAdddressTypeFrm: FormGroupDirective;

    currentDisplayValue = false;
    currentAddressTypeList = [];

    ngOnChanges(changes: SimpleChanges): void {

        if(changes.addressTypeList && changes.addressTypeList.currentValue){
            this.currentAddressTypeList = changes.addressTypeList.currentValue
        }

        if(changes.display && changes.display.currentValue != undefined){
            this.currentDisplayValue = changes.display.currentValue;
        }
    }

    ngOnInit(): void {

    }

    saveAddrType() {
        const addTypeExists = this.currentAddressTypeList.find(obj => obj.name.toLowerCase() == this.tempAddrType.name.toLowerCase())
        if (addTypeExists) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Address type already added' });
        } else {
            const newAddressType = {
                "id": 0,
                "createdSource": this.app.user.userIP,
                "updatedSource": null,
                "createdBy": this.app.user.userId,
                "updatedBy": null,
                "createdDate": new Date(),
                "updatedDate": null,
                "name": this.tempAddrType.name,
                "parentTypeId": 0,
                "description": null,
                "groupId": TypeGroupIds.AddressTypeCoreAPI,// as discussed with ankush it will be 11
                "organizationId": this.app.user.organizationId,
                "colorCodeId": 0,
                "statusId": Status.Active
            }
            this.appMainService.isShowSpinner('AddAddressType')
            this.addressTypeService.addAccounAddressType(newAddressType).subscribe(res => {
                this.appMainService.isHideSpinner('AddAddressType')
                this.onSave.emit({addressType: res})

                this.addAdddressTypeFrm.form.reset();
                this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Address Type added Sucessfully...' });
            }, err => {
                this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error occurred while adding address type' });
                this.appMainService.isHideSpinner('AddAddressType')
            });
        }


    }

    cancelAddressType(){
        this.onCancel.emit();
        this.addAdddressTypeFrm.form.reset();
    }


}
